/* HK back-to-collection (New Hakon store, draft theme).
   Collection/search pages save where the shopper is (title + exact URL incl. filters, sort, page) to sessionStorage.
   Product pages show "Back to <collection>" + a breadcrumb crumb when the shopper came from that page
   (or from another product page reached from it). Nothing known = link stays hidden. */
(function () {
  if (window.__hkBackToCollection) return;
  window.__hkBackToCollection = true;

  var KEY = 'hk:backctx';
  function read() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function write(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function isProductPath(path) { return /\/products\/[^\/]+/.test(path); }

  function saveCurrent() {
    var el = document.querySelector('[data-hk-ctx]');
    if (!el) return;
    var title = (el.getAttribute('data-hk-ctx-title') || '').trim();
    if (!title) return;
    write({
      type: el.getAttribute('data-hk-ctx'),
      title: title,
      path: location.pathname,
      url: location.pathname + location.search,
      ts: Date.now()
    });
  }

  function initListing() {
    saveCurrent();
    // Filters/sort/pagination can change the URL without a reload, so re-save at the moment a product is clicked.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      try {
        var u = new URL(a.href, location.href);
        if (u.origin === location.origin && isProductPath(u.pathname)) saveCurrent();
      } catch (err) {}
    }, true);
    window.addEventListener('pageshow', saveCurrent);
  }

  function show(row, href, title, type) {
    var link = row.querySelector('[data-hk-backlink]');
    var titleEl = row.querySelector('[data-hk-backlink-title]');
    var crumb = row.querySelector('[data-hk-crumb]');
    var crumbLink = row.querySelector('[data-hk-crumb-link]');
    if (link) {
      link.href = href;
      link.removeAttribute('hidden');
      link.setAttribute('title', 'Back to ' + title);
    }
    if (titleEl) titleEl.textContent = title;
    if (crumb && crumbLink) {
      crumbLink.href = href;
      crumbLink.textContent = type === 'search' ? 'Search results' : title;
      crumb.removeAttribute('hidden');
    }
    row.classList.add('hk-crumbrow--has-back');
  }

  function initProduct(row) {
    var saved = read();
    if (!saved || !saved.url || !saved.title) return; // keep server-rendered state (if any)

    var serverPath = row.getAttribute('data-hk-server-path') || '';
    if (serverPath) {
      // URL already has a collection context: only upgrade the link if it's the same collection (keeps filters/page).
      if (saved.path === serverPath) show(row, saved.url, saved.title, saved.type);
      return;
    }

    var ref = null;
    try { if (document.referrer) ref = new URL(document.referrer); } catch (e) {}
    var cameFromListing = ref && ref.origin === location.origin && ref.pathname === saved.path;
    var cameFromProduct = ref && ref.origin === location.origin && isProductPath(ref.pathname) && saved.chain;

    if (cameFromListing || cameFromProduct) {
      saved.chain = true; // allow product -> related product to keep the link
      write(saved);
      show(row, saved.url, saved.title, saved.type);
    } else {
      clear(); // arrived some other way (home, menu, cart, Google, new tab): don't guess
    }
  }

  function init() {
    var row = document.querySelector('[data-hk-crumbrow]');
    if (row) initProduct(row);
    if (document.querySelector('[data-hk-ctx]')) initListing();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
